import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
} from 'react-admin';

export const CharacteristicCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" validate={[required()]} fullWidth />
      <TextInput source="slug" fullWidth helperText="Автоматически генерируется из названия, если не указан" />
      <TextInput source="unit" label="Единица измерения" placeholder="кг, л.с., м³" />
      <TextInput source="description" multiline rows={3} fullWidth />
      
      <ReferenceInput source="groupId" reference="characteristic-groups">
        <SelectInput optionText="name" validate={[required()]} />
      </ReferenceInput>
      
      <NumberInput source="sortOrder" defaultValue={0} />
    </SimpleForm>
  </Create>
);
